import { useNavigate, useLocation } from "react-router-dom";

const navItems = [
  { path: "/", label: "首页", icon: "ri-home-5-line", activeIcon: "ri-home-5-fill" },
  { path: "/assistant", label: "助理", icon: "ri-seedling-line", activeIcon: "ri-seedling-fill" },
  { path: "/orders", label: "订单", icon: "ri-file-list-3-line", activeIcon: "ri-file-list-3-fill" },
  { path: "/profile", label: "我的", icon: "ri-user-3-line", activeIcon: "ri-user-3-fill" },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav
      className="customer-fixed-shell fixed bottom-0 z-50 bg-white"
      style={{
        borderTop: "1px solid #F0F0F0",
        paddingBottom: "env(safe-area-inset-bottom, 0px)",
      }}
    >
      <div className="flex min-w-0 items-center justify-around px-1" style={{ height: 64 }}>
        {navItems.map((item, idx) => {
          const isHome = item.label === "首页" && pathname === "/";
          const active = isHome || (item.path !== "/" && pathname === item.path);

          return (
            <button
              key={`${item.label}-${idx}`}
              onClick={() => navigate(item.path)}
              className="relative flex h-full min-w-0 flex-1 cursor-pointer flex-col items-center justify-center overflow-hidden whitespace-nowrap"
              style={{ gap: 3 }}
            >
              {/* Active background pill */}
              {active && (
                <div
                  className="absolute"
                  style={{
                    top: 8,
                    width: 40,
                    height: 28,
                    borderRadius: 14,
                    background: "linear-gradient(135deg, #FFF0E6 0%, #FFE4CC 100%)",
                  }}
                />
              )}
              <div
                className="w-6 h-6 flex items-center justify-center relative z-10 transition-transform duration-200"
                style={{ transform: active ? "scale(1.15)" : "scale(1)" }}
              >
                <i
                  className={`${active ? item.activeIcon : item.icon} text-xl`}
                  style={{ color: active ? "#FF6010" : "#C0C0C0" }}
                />
              </div>
              <span
                className="relative z-10 block max-w-full truncate px-1 font-medium"
                style={{ fontSize: 10, color: active ? "#FF6010" : "#C0C0C0", fontWeight: active ? 700 : 500 }}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
